import { Component } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-tooltip-page',
    templateUrl: './showroom-exhibit-tooltip-page.component.html',
    styleUrls: ['./showroom-exhibit-tooltip-page.component.scss'],
})

export class ShowroomExhibitTooltipPageComponent {}
